import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NOTAM } from '../models/notam.model';
import { Airport } from '../models/airport.model';
import { AirportService } from '../airport.service';

@Component({
  selector: 'app-notam-details',
  templateUrl: './notam-details.component.html',
  styleUrls: ['./notam-details.component.scss']
})
export class NotamDetailsComponent implements OnInit {
  airportFAAIdent: string;
  country: string;
  notams: NOTAM[];
  isLoading = true;

  constructor(private _matDialogRef: MatDialogRef<NotamDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _airportService: AirportService) {
    this.airportFAAIdent = data.FaaId;
    this.country = data.country;
  }

  async ngOnInit() {
    this.isLoading = true;
    this.notams = await this._airportService.getAirportNOTAMs(this.airportFAAIdent);
    this.notams = this.notams.filter(n => !n.isTfr);
    if (this.country === 'US') {
      this.notams = this.notams.filter(n => !n.notamId.startsWith('A'));
    }

    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.isLoading = false;
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
